import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgFacebook({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5v14a2 2 0 002 2h7.617v-6.47H10.27v-2.717h2.347V9.81c0-2.324 1.42-3.59 3.494-3.59.7-.003 1.4.033 2.096.107v2.428H16.77c-1.069 0-1.323.481-1.347 1.2l-.002 1.857h2.69l-.35 2.717h-2.34V21H19a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFacebook
